import { render, staticRenderFns } from "./OsItem.vue?vue&type=template&id=17786526&"
import script from "./OsItem.vue?vue&type=script&lang=js&"
export * from "./OsItem.vue?vue&type=script&lang=js&"
import style0 from "./OsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports